/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/getDiscountCouponList.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_DISCOUNT_CODES } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment";
import { pretty } from "@vlinder-web/utils-react";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetDiscountCouponListMethods extends IPluginMethodMap {
  getDiscountCouponList(args: any): Promise<any>;
}

export class getDiscountCouponListService implements IAgentPlugin {
  readonly methods: IGetDiscountCouponListMethods;

  constructor() {
    this.methods = {
      getDiscountCouponList: this.getDiscountCouponList.bind(this),
    };
  }

  async getDiscountCouponList(args?: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    console.log(pretty(args));
    let filter = {};
    if (args?.data?._id) {
      filter = {
        ...filter,
        _id: args?.data?._id
      }
    }
    if (args?.criteria?._data?.createdBy___email) {
      filter = {
        ...filter,
        createdBy___email: args?.criteria?._data?.createdBy___email
      }
    }
    if (args?.criteria?._data?.adminId___email) {
      filter = {
        ...filter,
        adminId___email: args?.criteria?._data?.adminId___email
      }
    }
    if (args?.criteria?._data?.committeeId___email) {
      filter = {
        ...filter,
        committeeId___email: args?.criteria?._data?.committeeId___email
      }
    }
    if (args?.criteria?._data?.masqId___email) {
      filter = {
        ...filter,
        masqId___email: args?.criteria?._data?.masqId___email
      }
    }

    if (args?.criteria?.statusFilter) {
      filter = {
        ...filter,
        discountCodes___status: args?.criteria?.statusFilter
      }
    }
    let variables = {
      filter: filter,
      options: {
        limit: args?.size ?? 10,
        skip: args?.offset ?? 0,
        sort: {
          field: "createdAt",
          order: "desc",
        },
      },
    };
    try {
      if (client) {
        const res = await client.query({
          query: GET_DISCOUNT_CODES,
          variables: variables,
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          let _rowData = this.formatTable(
            res?.data?.getAllDiscountCodes?.content
          );

          let _totalPages = res?.data?.getAllDiscountCodes?.count
            ? Math.ceil(parseInt(res?.data?.getAllDiscountCodes?.count) / 10)
            : 1;

          let _currentPage =
            res?.data?.getAllDiscountCodes?.skip /
            res?.data?.getAllDiscountCodes?.limit +
            1;
          console.log("_rowData==>", _rowData);
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getAllDiscountCodes?.content?.length <= 0,
            activePage: _currentPage,
            currentPage: _currentPage,
            pageSize: _rowData.length,
            totalCount: res?.data?.getAllDiscountCodes?.count,
            totalPages: _totalPages,
          };
        }
        return config;
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private formatTable(users: any[]): any {
    let _rowData: any = [];
    let totalPaid = users.length > 0 ? 0 : "";
    users &&
      users.forEach((data?: any) => {
        console.log(data)
        _rowData.push({
          name: data?.discountCodes?.discountCode,
          status: data?.discountCodes?.status,
          createdBy: data?.createdBy[0]?.email,
          admin: data?.adminId[0]?.email,
          committee: data?.committeeId[0]?.email,
          masq: data?.masqId[0]?.email
        });
      });
    return _rowData;
  }
}
